import React from "react";
import { CustomComponentCustomFormField, CustomFormSelection, MatrixRadioButtonsFormField, basicValidation } from "../../../../../amorg-common";
import { AnswerFieldContext } from "../../customFormFieldFactory";
import { RiskAssessmentHelper } from "./_components/RiskAssessmentHelper";

type Kim2RiskAssessmentCustomFormFieldComponentProps = AnswerFieldContext & {
    field:CustomComponentCustomFormField
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Kim2RiskAssessmentCustomFormFieldComponent(props:Kim2RiskAssessmentCustomFormFieldComponentProps):JSX.Element
{
    const timePointsField = props.answer.selections.find(s => s.fieldId === 'timePoints');
    const timePoints = parseNumberValue(timePointsField);

    const transportAndMovementField = props.answer.selections.find(s => s.fieldId === 'transportAndMovement');
    const transportAndMovementValue = transportAndMovementField.value;
    let transportAndMovementNumericalValue = 0;

    const transportAndMovementFormField = props.form.fields.find(f => f.fieldId === 'transportAndMovement') as MatrixRadioButtonsFormField;
    if(!transportAndMovementFormField)
        throw new Error('Missing field in form with fieldId = "transportAndMovement"');

    const transportAndMovementOptions = transportAndMovementFormField.sections.flatMap((s => s.rows.flatMap(r => r.options))).filter(o => o !== null);
    const selectedOption = transportAndMovementOptions.find(o => o.value === transportAndMovementValue);
    if(selectedOption)
        transportAndMovementNumericalValue = selectedOption.numericalValue || 0;

    // const positioningField = props.answer.selections.find(s => s.fieldId === 'positioning');
    // const positioning = parseNumberValue(positioningField);
    const positioningField = props.answer.selections.find(s => s.fieldId === 'positioning');
    const positioningValue = positioningField.value;
    let positioningNumericalValue = 0;

    const positioningFormField = props.form.fields.find(f => f.fieldId === 'positioning') as MatrixRadioButtonsFormField;
    if(!positioningFormField)
        throw new Error('Missing field in form with fieldId = "transportAndMovement"');

    const positioningOptions = positioningFormField.sections.flatMap((s => s.rows.flatMap(r => r.options))).filter(o => o !== null);
    const positioningSelectedOption = positioningOptions.find(o => o.value === positioningValue);
    if(selectedOption)
        positioningNumericalValue = positioningSelectedOption.numericalValue || 0;



    const workConditionField = props.answer.selections.find(s => s.fieldId === 'workCondition');
    const workCondition = parseNumberValue(workConditionField);

    const workPostureField = props.answer.selections.find(s => s.fieldId === 'workPosture');
    const workPosture = parseNumberValue(workPostureField);

    const riskField = props.answer.selections.find(s => s.fieldId === props.field.fieldId);
    const risk = parseNumberValue(riskField);

    const newRiskAssessmentValue = (transportAndMovementNumericalValue+positioningNumericalValue+workCondition+workPosture) * timePoints;
    const oldRiskAssessmentValue = risk || 0;

    React.useEffect(() => {
        const updateRiskAssessment = async (value:number) => {
            await props.onSubmit([{ fieldId:props.field.fieldId, value:value.toString()}]);
            props.doUpdate();
        };

        if(newRiskAssessmentValue !== oldRiskAssessmentValue)
        {
            updateRiskAssessment(newRiskAssessmentValue);
        }

    }, [timePoints, transportAndMovementNumericalValue, positioningNumericalValue, workCondition, workPosture]);
    
    return (
        <RiskAssessmentHelper
            {...props}
            riskAssessmentField={props.field}
            sumElements={[
                { text:'Transport- og forflytningshjælpemidler', value:transportAndMovementNumericalValue },
                { text:'Nøjagtighed ved positionering', value:positioningNumericalValue },
                { text:'Arbejdsstilling', value:workPosture },
                { text:'Arbejdsforhold', value:workCondition }
                
            ]}
            factorElements={[
                { text:'Tidspoint', value:timePoints },
                { text:'Fast værdi', value:1.3 }
            ]}
            document="kim2"
            
        />
    );
}

function parseNumberValue(field:CustomFormSelection):number | null
{
    if(field === null)
        return null;

    if(field === undefined)
        return null;

    if(!basicValidation.validateIntegerString(field.value))
        return null;


    return parseInt(field.value);
}